import { longQuarterNumberAndYear } from "../../agent-production/helpers/dataFormatters";
import { terms } from "../constants";

export const getBeginOrEndOptions = (optionType, agentData, formatter, setSelectedValue, selectedComplementValue) =>
    agentData?.map((period, index) => {
        return {
            dataLwtId: `${optionType === terms.begin ? 'begin-option' : 'end-option'}${index}`,
            value: optionType === terms.begin ? period.timePeriodStart : period.timePeriodEnd,
            itemText: formatter(period.timePeriodStart, longQuarterNumberAndYear),
            key: `item_${index}`,
            onClick: () => setSelectedValue(optionType === terms.begin ? period.timePeriodStart : period.timePeriodEnd)
        };
    }).reverse().filter((option) => {
        if (optionType === terms.begin) return new Date(selectedComplementValue) > new Date(option.value);
        return new Date(selectedComplementValue) < new Date(option.value);
    });
